module.exports = __webpack_public_path__ + "img/ANTOJITOS.8889a521.png";